export const environment = {
  name: 'production',
  production: true,
  dynatraceApiUrl: 'https://ydd08220.live.dynatrace.com/api/v2/otlp',
  dynatraceApiToken:
    'dt0c01.6P4ZJZYFA5N4MQ2YRQYCEUDN.7QMHVXLJDCNGFOZZNJLO4PPXAZOWOYKBTSJRZIBLZGYTPRN6QWTRGH5L6DH2DJKO',
  dynatraceRumScriptUrl:
    'https://js-cdn.dynatrace.com/jstag/16ad5abbf0d/bf23308xgg/8277d11fb10d67ca_complete.js',
  gaMeasurementId: 'G-FWP1C59GRL',
};
